<template>
	<page enable-flex style="background: #fff;">
		<scan ref="scan" :disabled="!!code" @scan="codeHandle">
			<div class="head">
				<h5>维修单位：{{codeInfo.repair_unit || '-'}}</h5>
				<p>{{productName || '-'}}</p>
			</div>

			<c-form ref="form">
				<c-form-item label="维修项（可多选）" required>
					<c-checkbox-group v-model="currentItemValue" name="items" :options="itemList"></c-checkbox-group>
				</c-form-item>
				<c-form-item v-for="item in currentItemData" :key="item.value" :label="`（${item.name}）维修金额`" required>
					<c-input v-model="itemSum[item.value]" type="number" :name="`item${item.value}`" decimal="2" append-text="元"></c-input>
				</c-form-item>
				<c-form-item label="备注">
					<c-input type="textarea" name="remark"></c-input>
				</c-form-item>
			</c-form>
		</scan>

		<template v-if="codeInfo.produce_unique_code" #button>
			<c-button color="main" hollow size="form" @click="mp.navigateBack()">取消</c-button>
			<c-button class="foot-button" size="form" color="main" @click="submitHandle">确认提交</c-button>
		</template>
	</page>
</template>

<script>
	export default {
		props: {
			code: String
		},

		data() {
			return {
				codeInfo: {},
				itemList: [],
				currentItemValue: [],
				itemSum: {}
			}
		},

		computed: {
			productName() {
				return [this.codeInfo.brand_name, this.codeInfo.model_name, this.codeInfo.color_name, this.codeInfo.memory_name].filter(item => item).join(' ');
			},

			currentItemData() {
				return this.itemList.filter(item => this.currentItemValue.includes(item.value.toString()));
			}
		},

		mounted() {
			if (this.code) {
				this.codeHandle(this.code);
			}
			this.request({
				url: '/system/dic/options',
				data: {
					dic_type_code: 'REPAIR_ITEM'
				},
				success: data => {
					this.itemList = data;
				}
			});
		},
		
		methods: {
			codeHandle(code) {
				this.request({
					url: '/repair/product/queryByCode',
					data: {
						produce_unique_code: code
					},
					success: data => {
						this.codeInfo = data;
					},
					fail: () => {
						this.$refs.scan.reset();
					}
				});
			},

			submitHandle() {
				let rule = {};
				this.currentItemValue.forEach(val => {
					rule[`item${val}`] = '请填写维修金额';
				});
				this.$refs.form.submit({
					url: '/repair/delivery/complete',
					rule: {
						items: '请选择维修项',
						...rule
					},
					dataFormatter: data => {
						return {
							id: this.codeInfo.delivery_id,
							produce_unique_code_id: this.codeInfo.produce_unique_code_id,
							produce_unique_code: this.codeInfo.produce_unique_code,
							items: JSON.stringify(this.currentItemValue.map(val => {
								return {
									repair_item: val,
									repair_amount: this.itemSum[val]
								}
							})),
							remark: data.remark
						}
					},
					success: () => {
						this.$message({
							message: '提交成功',
							mask: true
						});
						this.mp.navigateBack(true);
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	>>> .head {
		padding: .26rem;
		margin-bottom: .2rem;
		font-size: .26rem;
		text-align: center;
		color: #666;
		background: #EFF2FF;

		h5 {
			margin-bottom: .2rem;
			font-size: .32rem;
			color: var(--color-main);
		}
	}
</style>